import React, { useEffect, useState } from 'react';
import { TextField, MenuItem, Grid, Select, InputLabel, FormControl } from '@mui/material';
import GenericAddButton from 'widgets/GenericAddButton/GenericAddButton';
import SearchIcon from '@mui/icons-material/Search';
import { convertToMexicoTime } from 'utils/helpers/convertToMexicoTime';

const FiltroNetPay = ({ handleSubmit, onSubmit, register, errors }) => {
  const [currentDate, setCurrentDate] = useState('');

  useEffect(() => {
    const today = new Date().toISOString();
    const todayMexico = convertToMexicoTime(today);
    setCurrentDate(todayMexico.split(' ')[0]);
  }, []);

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={1} alignItems='center'>
        <Grid size={{ xs: 12, sm: 12, md: 1.7, xl: 1.7 }}>
          <TextField
            fullWidth
            label='*Desde'
            type='date'
            {...register('from_date')}
            InputLabelProps={{
              shrink: true,
            }}
            error={Boolean(errors.from_date)}
            helperText={errors.from_date?.message}
            slotProps={{
              htmlInput: {
                max: currentDate,
              },
            }}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 12, md: 1.7, xl: 1.7 }}>
          <TextField
            fullWidth
            label='*Hasta'
            type='date'
            {...register('to_date')}
            InputLabelProps={{
              shrink: true,
            }}
            error={Boolean(errors.to_date)}
            helperText={errors.to_date?.message}
            slotProps={{
              htmlInput: {
                max: currentDate,
              },
            }}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 12, md: 1.7, xl: 1.7 }}>
          <FormControl fullWidth>
            <InputLabel id='demo-simple-select-label'>Status</InputLabel>
            <Select
              fullWidth
              {...register('status_id')}
              error={Boolean(errors.status_id)}
              helperText={errors.status_id?.message}
            >
              <MenuItem value={1}>Solicitado</MenuItem>
              <MenuItem value={2}>Éxito</MenuItem>
              <MenuItem value={3}>Fallo</MenuItem>
              <MenuItem value={4}>Revisión</MenuItem>
              <MenuItem value={5}>Error</MenuItem>
            </Select>
          </FormControl>
        </Grid>

        <Grid size={{ xs: 12, sm: 12, md: 1.7, xl: 1.7 }}>
          <TextField
            fullWidth
            label='*Autorización'
            {...register('authorization_code')}
            error={Boolean(errors.authorization_code)}
            helperText={errors.authorization_code?.message}
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 12, md: 1.7, xl: 1.7 }}>
          <TextField
            fullWidth
            label='*Tarjeta'
            {...register('masked_pan_termination', {
              pattern: {
                value: /^[0-9Xx*]+$/,
                message: 'Solo se permiten números',
              },
            })}
            error={Boolean(errors.masked_pan_termination)}
            helperText={errors.masked_pan_termination?.message}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 12, md: 1.7, xl: 1.7 }}>
          <TextField
            fullWidth
            label='Monto'
            type='number'
            {...register('amount')}
            error={Boolean(errors.amount)}
            helperText={errors.amount?.message}
            onWheel={(e) => e.target.blur()}
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 12, md: 1.7, xl: 1.7 }}>
          <GenericAddButton
            buttonText='Buscar'
            backgroundColor='#4C2484'
            size='medium'
            isSubmit
            icon={<SearchIcon />}
          />
        </Grid>
      </Grid>
    </form>
  );
};

export default FiltroNetPay;
